




















































































































































































































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import base64toUInt8Array, { openPdfInNewTab } from "@/utils/fileConvert";
import store, { GeneralLedgerStore } from "../services/store";
import api from "../services/api";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import CheckBox from "@/components/CheckBox.vue";
import DateInput from "@/components/DateInput.vue";
import StatementSelectorTabs from "../components/StatementSelectorTabs.vue";
import SpecialDimensionFilterButton from "@/components/SpecialDimensionFilterButton.vue";
import SpecialDimensionFilterValue, { emptySpecialDimensionFilter } from "@/modules/specialDimension/models/SpecialDimensionFilter";
import PowerBIApi from "@/modules/powerBI/services/PowerBIApi";
import Report, { PowerBIReportType } from "@/modules/powerBI/models/Report";
import {
  GeneralLedgerStatementFilter,
  DefaultGeneralLedgerStatementFilter,
  NewGeneralLedgerStatementFilter,
  StatementReportType,
} from "../models/GeneralLedgerStatement";

interface FlagDef {
  key: keyof GeneralLedgerStatementFilter;
  label: string;
}
interface DimFilterDef {
  enableKey: keyof GeneralLedgerStatementFilter;
  fromKey: keyof GeneralLedgerStatementFilter;
  toKey: keyof GeneralLedgerStatementFilter;
  groupKey: keyof GeneralLedgerStatementFilter;
  label: string;
  type: number; // AccountingDimCode.type: dim1=2, dim2=3, dim3=4.
}
interface Option {
  value: any;
  text: string;
}

interface Data {
  store: GeneralLedgerStore;
  filter: GeneralLedgerStatementFilter;
  /** K2D w_specdim: speciális dimenzió Tól/Ig szűrő (generáláskor kerül a filterbe) */
  specDim: SpecialDimensionFilterValue;
  accnoOptions: any[];
  dimcodeOptions: any[];
  generating: boolean;
  /** A mód szerinti (kivonat/karton) Power BI riport a pmsyspowerbireport-ból; null = nincs, a gomb letiltott */
  biReport: Report | null;
  /** A "Riport beállítások" kapcsoló-panelek nyitva/csukva állapota (helytakarékosság) */
  settingsOpen: boolean;
  /** A "Dimenzió szűrés" szekció nyitva/csukva állapota */
  dimFilterOpen: boolean;
  itemTypeFlags: FlagDef[];
  commonDisplayFlags: FlagDef[];
  briefDisplayFlags: FlagDef[];
  cartonDisplayFlags: FlagDef[];
  summaryFlags: FlagDef[];
  dimFilters: DimFilterDef[];
  sortByOptions: Option[];
  payModeOptions: Option[];
  reconIncludeOptions: Option[];
}
interface Methods {
  applyModeDefaults(): void;
  loadAccnoOptions(): void;
  loadDimcodeOptions(): void;
  loadPayModeOptions(): void;
  setAccno(field: "fromAccno" | "toAccno", e: any): void;
  setDim(field: keyof GeneralLedgerStatementFilter, e: any): void;
  dimOptions(type: number): any[];
  setFlag(key: keyof GeneralLedgerStatementFilter, value: boolean): void;
  onSelection(sel: Partial<GeneralLedgerStatementFilter>): void;
  onDate(field: "fromDate" | "toDate", value: Date | null): void;
  applyDefaultDates(): void;
  syncYearFromDate(): void;
  extractField(e: any, key: string): string;
  applySpecDimToFilter(): void;
  generatePdf(): void;
  loadBiReport(): void;
  openBiReport(): void;
  reset(): void;
}
interface Computed {
  calendarYear: number;
  displayFlags: FlagDef[];
}
interface Props {
  cartonMode: boolean;
}

const fmtDate = (d: Date): string => {
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { LookupComboBox, CheckBox, DateInput, StatementSelectorTabs, SpecialDimensionFilterButton },

  props: {
    // A route adja meg (kivonat = false, karton = true). Két route, egy komponens.
    cartonMode: { type: Boolean, default: false },
  },

  data(): Data {
    return {
      store,
      filter: NewGeneralLedgerStatementFilter(),
      specDim: emptySpecialDimensionFilter(),
      accnoOptions: [],
      dimcodeOptions: [],
      generating: false,
      biReport: null,
      settingsOpen: true,
      dimFilterOpen: true,
      itemTypeFlags: [
        { key: "isManual", label: "Manuális" },
        { key: "isMachine", label: "Gépi" },
        { key: "isStorno", label: "Sztornózott is" },
        { key: "isAcross", label: "Átvezetés is" },
      ],
      commonDisplayFlags: [
        { key: "isPartner0", label: "0 egyenlegű fősz. is" },
        { key: "noPartner", label: "Partner nélküliek" },
        { key: "isEnlNote", label: "Bővített megjegyzés" },
        { key: "ejectAfter", label: "Lapdobás számla után" },
        { key: "invoiceGroup", label: "Számlánként csop." },
        { key: "isMix", label: "Készletmozgások" },
      ],
      // K2D-ben az is_contra_acc EGYETLEN mező, amit a mód átcímkéz (srw:2250-2252 / 4541), ezért
      // módonként csak az egyik jelenik meg: kivonaton "Szintek stíl. kül." (→ is_grey formula),
      // kartonon "Összesítő ellenszámla" (→ ell_fsz formula).
      briefDisplayFlags: [
        { key: "isLevelStyleDiff", label: "Szintek stíl. kül." },
      ],
      cartonDisplayFlags: [
        { key: "isContraAcc", label: "Összesítő ellenszámla" },
        { key: "ejectAfterAccno", label: "Lapdobás fksz. után" },
        { key: "connectedAccno", label: "Kapcs. fksz." },
        { key: "showTransId", label: "Tr.azon. látható" },
      ],
      summaryFlags: [
        { key: "getGeneralLedger", label: "Főkönyvi szám" },
        { key: "getAccumulator", label: "Gyűjtő" },
        { key: "getAccountClass", label: "Számlaosztály" },
      ],
      dimFilters: [
        { enableKey: "isDimcode1", fromKey: "fromDimcode1", toKey: "toDimcode1", groupKey: "isGroupDim1", label: "Dimenzió I.", type: 2 },
        { enableKey: "isDimcode2", fromKey: "fromDimcode2", toKey: "toDimcode2", groupKey: "isGroupDim2", label: "Dimenzió II.", type: 3 },
        { enableKey: "isDimcode3", fromKey: "fromDimcode3", toKey: "toDimcode3", groupKey: "isGroupDim3", label: "Dimenzió III.", type: 4 },
      ],
      // K2D rendez értékkészlet (d_f_hlboktmpexp_brief.srd:39).
      sortByOptions: [
        { value: "1", text: "Dátum" },
        { value: "2", text: "Összeg" },
        { value: "3", text: "Partner" },
        { value: "4", text: "Számlaszám" },
      ],
      // K2D dddw_paymode: a "-" (szam=1) sor a default; az élő módok betöltéskor kerülnek mellé.
      payModeOptions: [{ value: 1, text: "-" }],
      reconIncludeOptions: [
        { value: "all", text: "Mind" },
        { value: "needed", text: "Kellenek" },
        { value: "notNeeded", text: "Nem kellenek" },
      ],
    };
  },

  async beforeMount() {
    this.filter.reportType = this.cartonMode ? StatementReportType.Carton : StatementReportType.Brief;
    this.applyModeDefaults();
    this.applyDefaultDates();
    // A "Fizetés módja" legördülő csak kartonon látszik – csak ott töltjük.
    if (this.cartonMode) this.loadPayModeOptions();
    this.loadBiReport();
    await this.store.setYears();
    this.syncYearFromDate();
  },

  computed: {
    calendarYear(): number {
      return this.filter.fromDate ? Number(this.filter.fromDate.slice(0, 4)) : 0;
    },
    displayFlags(): FlagDef[] {
      const base = this.cartonMode
        ? this.commonDisplayFlags.concat(this.cartonDisplayFlags)
        : this.commonDisplayFlags.concat(this.briefDisplayFlags);
      return base.map((f) => {
        // Gépjármű szerinti csoportosításnál a "Partner nélküliek" → "Gépjármű nélküliek".
        if (f.key === "noPartner") {
          return { key: f.key, label: this.filter.isCar ? "Gépjármű nélküliek" : "Partner nélküliek" };
        }
        // K2D: kartonon "0 egyen. partner", kivonaton "0 egyenlegű fksz. is" a felirat.
        if (f.key === "isPartner0") {
          return { key: f.key, label: this.cartonMode ? "0 egyenlegű partner is" : "0 egyenlegű fősz. is" };
        }
        return f;
      });
    },
  },

  methods: {
    // Módfüggő K2D-defaultok: az is_contra_acc initial '+' (kartonon "Össz. ell. számla" alapból be),
    // a kivonat-open viszont '-'-ra állítja (srw 2250).
    applyModeDefaults() {
      this.filter.isContraAcc = this.cartonMode;
    },

    // K2D default: kezdő = aktuális hónap 1., vég = ma (nem év eleje – különben az idei nyitó kimaradna).
    applyDefaultDates() {
      const now = new Date();
      this.filter.fromDate = fmtDate(new Date(now.getFullYear(), now.getMonth(), 1));
      this.filter.toDate = fmtDate(now);
    },

    async loadAccnoOptions() {
      if (!this.calendarYear) { this.accnoOptions = []; return; }
      this.accnoOptions = await api.GetInvoiceMirrorsByYear(this.calendarYear);
    },

    async loadDimcodeOptions() {
      if (!this.calendarYear) { this.dimcodeOptions = []; return; }
      this.dimcodeOptions = await api.GetStatementDimensions(this.calendarYear);
    },

    // "Fizetés módja" opciók (karton) – K2D dddw_paymode: "szam=1 OR live_dead=1", azaz a "-"
    // placeholder sor (szam=1, ez a default) + az élő fizetési módok. A payment-mode végpont csak
    // az élőket adja (a "-" sor halott lehet), ezért a "-"-t mi fűzzük az élre.
    // A filter.payMode → hlboktmpext.pmode → spp_boktmpext1 al_fizmod (1 = mind; sfp_pmode_num-hoz hasonlít).
    async loadPayModeOptions() {
      try {
        const modes = await api.GetStatementPayModes();
        this.payModeOptions = [
          { value: 1, text: "-" },
          ...modes.filter((m) => Number(m.id) > 1).map((m) => ({ value: Number(m.id), text: m.name })),
        ];
      } catch (e) {
        console.error("Fizetési módok betöltése sikertelen", e);
      }
    },

    dimOptions(type) {
      return this.dimcodeOptions.filter((d) => Number(d.type) === type);
    },

    extractField(e, key): string {
      if (!e) return "";
      if (typeof e === "string") return e;
      return e[key] ?? "";
    },

    setAccno(field, e) {
      this.filter[field] = this.extractField(e, "accno");
    },

    // A választó-fülek kijelölés-listái (a payload kulcsai a filter mezőnevei).
    onSelection(sel) {
      Object.assign(this.filter, sel);
    },

    setDim(field, e) {
      const value = this.extractField(e, "dimcode");
      (this.filter as any)[field] = value;
      // K2D (dw_1::itemchanged 'from_dimcode1..3' ág): a -tól érték automatikusan átmásolódik a -ig mezőbe.
      if (typeof field === "string" && field.startsWith("fromDimcode")) {
        (this.filter as any)["toDimcode" + field.slice("fromDimcode".length)] = value;
      }
    },

    // K2D itemchanged kaszkádok (kölcsönösen kizáró / feltételes mezők).
    setFlag(key, value) {
      (this.filter as any)[key] = value;

      // K2D (src/w_popup_report_brief.srw dw_1::itemchanged, 'is_open_only' ág): + esetén az
      // is_open_total/from_first MELLETT az is_prev_close is '-'-ra áll.
      if (key === "isOpenOnly" && value) {
        this.filter.isOpenTotal = false;
        this.filter.fromFirst = false;
        this.filter.isPrevClose = false;
      }
      if (key === "isOpenTotal") { if (value) this.filter.isOpenOnly = false; else this.filter.fromFirst = false; }
      if (key === "isCloseOnly" && value) this.filter.isClosed = true;
      if (key === "isClosed" && !value) this.filter.isCloseOnly = false;
      // K2D ('partner_gr'/'is_car' ágak): a csoportosítás VÁLTÁSAKOR a "…után lapdobás" mindig visszaáll.
      if (key === "isPartner" || key === "isCar") this.filter.partnerCarNewPage = false;
      if (key === "isPartner" && value) this.filter.isCar = false;
      if (key === "isCar" && value) {
        this.filter.isPartner = false;
        // Gépjármű csoportosításnál eltűnik a dimenzió-csoportosítás → töröljük.
        this.filter.isGroupDim1 = false;
        this.filter.isGroupDim2 = false;
        this.filter.isGroupDim3 = false;
      }

      // Lapdobás fksz. után ↔ Lapdobás szo. után kölcsönösen kizáró (egyszerre csak egy).
      if (key === "ejectAfterAccno" && value) this.filter.ejectAfter = false;
      if (key === "ejectAfter" && value) this.filter.ejectAfterAccno = false;

      // Dimenzió szerinti csoportosítás: a három közül csak egy lehet aktív.
      if (key === "isGroupDim1" && value) { this.filter.isGroupDim2 = false; this.filter.isGroupDim3 = false; }
      if (key === "isGroupDim2" && value) { this.filter.isGroupDim1 = false; this.filter.isGroupDim3 = false; }
      if (key === "isGroupDim3" && value) { this.filter.isGroupDim1 = false; this.filter.isGroupDim2 = false; }

      if (key === "isDimcode1" && !value) { this.filter.fromDimcode1 = "0"; this.filter.toDimcode1 = "ZZZZZZZZZZ"; }
      if (key === "isDimcode2" && !value) { this.filter.fromDimcode2 = "0"; this.filter.toDimcode2 = "ZZZZZZZZZZ"; }
      if (key === "isDimcode3" && !value) { this.filter.fromDimcode3 = "0"; this.filter.toDimcode3 = "ZZZZZZZZZZ"; }
    },

    onDate(field, value) {
      const next = value ? fmtDate(value) : null;
      // K2D (dw_1::itemchanged 'to_date' ág): a végdátum nem lehet kisebb a kezdő dátumnál.
      if (field === "toDate" && next && this.filter.fromDate && next < this.filter.fromDate) {
        eventBus.$emit("error", "A kezdő dátumnak kisebbnek kell lennie a végdátumnál!");
        return;
      }
      this.filter[field] = next;
      if (field === "fromDate") this.syncYearFromDate();
    },

    // A könyvelési év a Kezdő dátum évéből (mmbokyear), nincs külön év-választó.
    syncYearFromDate() {
      const years = this.store.years;
      if (!this.filter.fromDate || years.length === 0) return;
      const d = new Date(this.filter.fromDate);
      let match = years.find((yr) => new Date(yr.startDate) <= d && d <= new Date(yr.endDate));
      if (!match) {
        const ys = this.filter.fromDate.slice(0, 4);
        match = years.find((yr) => yr.year === Number(ys) || (yr.name || "").includes(ys));
      }
      const resolved = match ? match.id : years[0].id;
      if (resolved !== this.filter.yearId) this.filter.yearId = resolved;
    },

    // Spec. dimenzió Tól/Ig a payloadba (a backend normalizál: trim + üres Ig → Tól+'Z').
    // Közös a PDF- és a BI-riport előtt: mindkettő ugyanazt a filtert küldi.
    applySpecDimToFilter() {
      this.filter.specDim1From = this.specDim.from1;
      this.filter.specDim1To = this.specDim.to1;
      this.filter.specDim2From = this.specDim.from2;
      this.filter.specDim2To = this.specDim.to2;
      this.filter.specDim3From = this.specDim.from3;
      this.filter.specDim3To = this.specDim.to3;
      this.filter.specDim4From = this.specDim.from4;
      this.filter.specDim4To = this.specDim.to4;
    },

    async generatePdf() {
      if (!this.filter.yearId) {
        eventBus.$emit("error", "Válasszon könyvelési évet!");
        return;
      }
      this.generating = true;
      // Teljes képernyős busy overlay (Layout <busy-indicator>) a Crystal-generálás idejére.
      eventBus.$emit("busy-message", true);
      try {
        this.applySpecDimToFilter();
        const base64 = await api.GenerateGeneralLedgerStatementPdf(this.filter);
        if (!base64) {
          eventBus.$emit("error", "A riport generálása nem sikerült!");
          return;
        }
        openPdfInNewTab(base64toUInt8Array(base64));
      } catch (error) {
        eventBus.$emit("error", "A riport generálása nem sikerült!");
        console.error(error);
      } finally {
        this.generating = false;
        eventBus.$emit("busy-message", false);
      }
    },

    // A főkönyvi Power BI riport (pmsyspowerbireport.report_type = 3 "Főkönyv") – kivonat és karton KÖZÖS
    // (user-döntés 2026-09-07); a mód a hlboktmpext fejben van, a riport onnan tudja. Több sor esetén az
    // első él (CashFlow-minta). Hiba/üres lista → null, a gomb letiltott marad – a képernyő többi része megy.
    async loadBiReport() {
      try {
        const reports = await PowerBIApi.getAllByType(PowerBIReportType.GeneralLedger);
        this.biReport = reports && reports.length > 0 ? reports[0] : null;
      } catch (error) {
        this.biReport = null;
        console.error(error);
      }
    },

    // "BI Riport": a PDF-fel KÖZÖS adat-előkészítés (hlboktmpext fej + spp_boktmpext1), majd a beágyazott
    // Power BI riport új fülön, a fej-azonosítóval mint szűrő (PowerBIPage ?head=<id>). Ugyanazok a
    // validációk és a specdim-átadás, mint a PDF-nél, hogy a két kimenet ugyanazt a számot mutassa.
    async openBiReport() {
      if (!this.biReport) return;
      if (!this.filter.yearId) {
        eventBus.$emit("error", "Válasszon könyvelési évet!");
        return;
      }
      this.generating = true;
      eventBus.$emit("busy-message", true);
      try {
        this.applySpecDimToFilter();
        const headId = await api.PrepareGeneralLedgerStatementBiReport(this.filter);
        if (!headId) {
          eventBus.$emit("error", "A riport adat-előkészítése nem sikerült!");
          return;
        }
        // A pmsyspowerbireport filter_panel_off / nav_con_panel_off flagje query-ben megy a beágyazó oldalnak
        // (csak a kikapcsolást küldjük; hiányzó paraméter = panel bekapcsolva, CashFlow-kompatibilisen).
        const query: Record<string, string> = { head: String(headId) };
        if (this.biReport.filterPanelOff) query.filterPane = "0";
        if (this.biReport.navPanelOff) query.navPane = "0";
        const routeData = this.$router.resolve({
          name: "PowerBIPage",
          params: { id: this.biReport.reportId, paramId: String(this.biReport.paramId) },
          query,
        });
        window.open(routeData.href, "_blank");
      } catch (error) {
        // A backend BusinessRuleException-jét (pl. "nem történt könyvelés", lejárt Azure-kulcs)
        // a handleApiResponse már kiírta – itt csak a váratlan hibát jelezzük.
        console.error(error);
      } finally {
        this.generating = false;
        eventBus.$emit("busy-message", false);
      }
    },

    reset() {
      const type = this.cartonMode ? StatementReportType.Carton : StatementReportType.Brief;
      this.filter = { ...NewGeneralLedgerStatementFilter(), reportType: type };
      this.specDim = emptySpecialDimensionFilter();
      this.applyModeDefaults();
      this.applyDefaultDates();
      this.syncYearFromDate();
      // A fülek pipái is törlődnek (az emitjük az üres listákat visszaírja a friss filterbe).
      (this.$refs.selectorTabs as any)?.clearAll();
    },
  },

  watch: {
    // Védőháló arra az esetre, ha a router valaha újrahasznosítaná a példányt a két route között
    // (külön route-recordoknál jellemzően újrapéldányosít, ilyenkor a beforeMount fedi le).
    cartonMode(next: boolean) {
      this.filter.reportType = next ? StatementReportType.Carton : StatementReportType.Brief;
      this.applyModeDefaults();
      this.loadBiReport();
    },
    "filter.yearId"() {
      this.filter.fromAccno = DefaultGeneralLedgerStatementFilter.fromAccno;
      this.filter.toAccno = DefaultGeneralLedgerStatementFilter.toAccno;
      this.loadAccnoOptions();
      this.loadDimcodeOptions();
    },
  },
});
